// Shared `{{var}}` interpolation helpers used by the SPA. The actual
// substitution at run time happens on the Worker / agent — these are just
// for previewing what will be sent.

export function interpolate(text: string, vars: Record<string, string>): string {
  return text.replace(/\{\{\s*([a-zA-Z0-9_.-]+)\s*\}\}/g, (_m, name) => vars[name] ?? `{{${name}}}`);
}

export interface VarRef { name: string; start: number; end: number; resolved: string | undefined }

// Find every `{{var}}` in a string. Used to highlight unresolved refs and
// to build a tooltip showing the would-be resolved value.
export function findVars(text: string, vars: Record<string, string>): VarRef[] {
  const out: VarRef[] = [];
  const re = /\{\{\s*([a-zA-Z0-9_.-]+)\s*\}\}/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(text)) !== null) {
    out.push({ name: m[1], start: m.index, end: m.index + m[0].length, resolved: vars[m[1]] });
  }
  return out;
}
